import { AuthenticationFormProps } from '@dtx-company/inter-app/src/components/Authentication/AuthenticationForm.types'
import { Box, Stack } from '@dtx-company/design-system/src'
import { LOGGED_OUT_GENERATOR_SECTIONS } from '../LoggedOutCodeGenerator.constants'
import { ScanDestination } from '../GeneratorSections/ScanDestination/ScanDestination'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useScrollableContainerState } from './hooks/useScrollableContainerState'
import { useSelector } from '@xstate/react'
import React from 'react'
import dynamic from 'next/dynamic'

const AuthenticationForm = dynamic<AuthenticationFormProps>(() =>
  import('@dtx-company/inter-app/src/components/Authentication/AuthenticationForm').then(
    mod => mod.AuthenticationForm
  )
)

export const ScrollableContainer: React.FC = () => {
  const { locgService } = useGlobalServices()
  const { sectionRefs, rootContainerRef } = useScrollableContainerState()
  const displayScanDestination = useSelector(locgService, state => state.matches('scanDestination'))
  const displayCodeDesign = useSelector(locgService, state => state.matches('codeDesign'))
  const displayAuthForm = useSelector(locgService, state => state.matches('auth'))
  return (
    <Stack
      sx={theme => ({
        height: '100%',
        overflowY: 'auto',
        px: 8,
        pb: 50, // reserve space for last element to snap to the top
        scrollSnapType: 'y mandatory',
        maxWidth: {
          md: theme.spacing(136)
        },
        // hide scrollbar
        '::-webkit-scrollbar': {
          display: 'none'
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
      })}
      ref={rootContainerRef}
      spacing={{
        xs: 8,
        md: 16
      }}
    >
      {displayScanDestination && <ScanDestination />}
      {displayCodeDesign &&
        LOGGED_OUT_GENERATOR_SECTIONS.map((loggedOutGeneratorSection, i) => (
          <Box
            key={loggedOutGeneratorSection.id}
            id={loggedOutGeneratorSection.id}
            ref={el => {
              sectionRefs.current[i] = el as HTMLDivElement
            }}
            sx={{
              scrollSnapAlign: 'start'
            }}
          >
            <loggedOutGeneratorSection.Component />
          </Box>
        ))}
      {displayAuthForm && (
        <Stack
          sx={theme => ({
            maxWidth: theme.spacing(135),
            width: '100%',
            alignSelf: { xs: 'center', md: 'left' },
            p: {
              xs: theme.spacing(5, 0, 5),
              md: theme.spacing(10, 0, 5),
              lg: theme.spacing(10, 0, 13)
            }
          })}
        >
          <AuthenticationForm isSignIn={false} />
        </Stack>
      )}
    </Stack>
  )
}
